import Vue from 'vue';

import CachedCompanyData from '@/cache/CachedCompanyData';

export default class CachedCompanyStatuses extends CachedCompanyData {
  async retrieveData() {
    const response = await Vue.prototype.$globals.companyClient.getCompanyTaskStatuses();
    return response.results;
  }

  getCacheExpiration() {
    return 100000;
  }
}
